import React from "react"
import CIcon from "@coreui/icons-react"
import {
  cilDrop,
  cilPeople,
  cilAddressBook,
  cilLayers,
  cilUser,
  cilMobile,
  cilList,
  cilCog,
  cilClone,
} from "@coreui/icons"
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react"

const _nav = [
  {
    component: CNavItem,
    name: "Рассылки",
    to: "/mailings",
    icon: <CIcon icon={cilMobile} customClassName='nav-icon' />,
    mnemo: "mailings",
  },
  {
    component: CNavItem,
    name: "Клиенты",
    to: "/clients",
    icon: <CIcon icon={cilPeople} customClassName='nav-icon' />,
    mnemo: "clients",
  },
  {
    component: CNavItem,
    name: "Абонементы",
    to: "/abonements",
    icon: <CIcon icon={cilAddressBook} customClassName='nav-icon' />,
    mnemo: "abonements",
  },
  {
    component: CNavGroup,
    name: "Администратор",
    icon: <CIcon icon={cilLayers} customClassName='nav-icon' />,
    mnemo: "administrator",
    items: [
      {
        component: CNavItem,
        name: "Сертификаты",
        to: "/admin/certificates",
        mnemo: "certificateTable",
      },
      {
        component: CNavItem,
        name: "Тренеры",
        to: "/admin/trainers",
        mnemo: "employs",
      },
      {
        component: CNavItem,
        name: "Клубы",
        to: "/admin/clubs",
        mnemo: "clubs",
      },
      {
        component: CNavItem,
        name: "Типы клубов",
        to: "/admin/clubTypes",
        mnemo: "clubTypes",
      },
      {
        component: CNavItem,
        name: "Оплаты",
        to: "/admin/payments",
        mnemo: "payments",
      },
      {
        component: CNavItem,
        name: "Контроль бронирований",
        to: "/admin/bookings",
        mnemo: "booking",
      },
      {
        component: CNavItem,
        name: "Акции",
        to: "/admin/stocks",
        mnemo: "stocks",
      },
      {
        component: CNavItem,
        name: "Проходы",
        to: "/admin/passages",
        mnemo: "passages",
      },
      {
        component: CNavItem,
        name: "Услуги",
        to: "/admin/services",
        mnemo: "services",
      },
      {
        component: CNavItem,
        name: "Временные слоты",
        to: "/admin/slots",
        mnemo: "slots",
      },
      {
        component: CNavItem,
        name: "Расписание",
        to: "/admin/schedule",
        mnemo: "schedules",
      },
      {
        component: CNavItem,
        name: "Залы",
        to: "/admin/gyms",
        mnemo: "classes",
      },
      {
        component: CNavItem,
        name: "Типы тренировок",
        to: "/admin/trainings",
        mnemo: "trainingTypes",
      },
      {
        component: CNavItem,
        name: "Галерея",
        to: "/admin/galery",
        mnemo: "gallery",
      },
      {
        component: CNavItem,
        name: "Записи",
        to: "/admin/trainingRecords",
        mnemo: "records",
      },
      {
        component: CNavItem,
        name: "Оплата тренерам",
        to: "/admin/paymentsToTrainers",
        mnemo: "trainersPaymentTable",
      },
      {
        component: CNavItem,
        name: "Пакеты тренировок",
        to: "/admin/personalPackets",
        mnemo: "personalPackets",
      },
      {
        component: CNavItem,
        name: "Персональные тренировки",
        to: "/admin/personalTrainings",
        mnemo: "personalTrainingsTable",
      },
      {
        component: CNavItem,
        name: "Расписание тренеров",
        to: "/admin/employWorktimes",
        mnemo: "employWorktimesTable",
      },
      {
        component: CNavItem,
        name: "Пакеты услуг",
        to: "/admin/packetsServices",
        mnemo: "trainingsPackets",
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Рейтинг",
    icon: <CIcon icon={cilUser} customClassName='nav-icon' />,
    mnemo: "usersRating",
    items: [
      {
        component: CNavItem,
        name: "Рейтинг пользователей",
        to: "/usersRating/rating",
        mnemo: "rating"
      },
      {
        component: CNavItem,
        name: "Начисление баллов",
        to: "/usersRating/accuralPointsRules",
        mnemo: "accuralPointsRules"
      },
      {
        component: CNavItem,
        name: "Гонки",
        to: "/usersRating/races",
        mnemo: "races"
      },
    ]
  },
  {
    component: CNavGroup,
    name: "Аккаунты",
    icon: <CIcon icon={cilUser} customClassName='nav-icon' />,
    mnemo: "accounts",
    items: [
      {
        component: CNavItem,
        name: "Пользователи",
        to: "/account/users",
        mnemo: "users",
      },
      {
        component: CNavItem,
        name: "Роли",
        to: "/account/permissions",
        mnemo: "roles",
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Подписки",
    icon: <CIcon icon={cilList} className='nav-icon' />,
    mnemo: "recurrents",
    items: [
      {
        component: CNavItem,
        name: "Отмена подписки",
        to: "/subscribes/cancelSubscribes",
        mnemo: "cancelRecurrent",
      },
      {
        component: CNavItem,
        name: "Уведомления об оплате",
        to: "/subscribes/paymentReminders",
        mnemo: "paymentReminder",
      },
    ],
  },
  {
    component: CNavItem,
    name: "Версии",
    to: "/versions",
    icon: <CIcon icon={cilClone} customClassName='nav-icon' />,
    mnemo: "versions",
  },
  {
    component: CNavItem,
    name: "Параметры",
    to: "/params",
    icon: <CIcon icon={cilCog} customClassName='nav-icon' />,
    mnemo: "params",
  },
  {
    component: CNavGroup,
    name: "Документы",
    icon: <CIcon icon={cilList} className='nav-icon' />,
    mnemo: "documents",
    items: [
      {
        component: CNavItem,
        name: "Клубы",
        to: "/documents/clubs",
        mnemo: "clubDocuments",
      },
    ],
  },
]

export default _nav
